import { Grid, Typography } from '@mui/material';
import { useState } from 'react';

export enum DamagedPartCodes {
  // Left
  LEFT_FRONT_WHEEL = '10',
  LEFT_FENDER = 'LF',
  LEFT_FRONT_DOOR = '20',
  LEFT_REAR_DOOR = '30',
  LEFT_QUARTER_PANEL = 'LQ',
  LEFT_REAR_WHEEL = '40',
  // Center
  FRONT_BUMPER = '01',
  HOOD = '11',
  FRONT_WINDSHIELD = 'FW',
  ROOF = '21',
  REAR_WIND_SHIELD = 'BW',
  TRUNK = '41',
  REAR_BUMPER = '51',
  // Right
  RIGHT_FRONT_WHEEL = '12',
  RIGHT_FENDER = 'RF',
  RIGHT_FRONT_DOOR = '22',
  RIGHT_REAR_DOOR = '32',
  RIGHT_QUARTER_PANEL = 'RQ',
  RIGHT_REAR_WHEEL = '42',
}

enum DamagedPartName {
  FRONT_WHEEL = 'Front Wheel',
  FENDER = 'Fender',
  FRONT_DOOR = 'Front Door',
  REAR_DOOR = 'Rear Door',
  QUARTER_PANEL = 'Quarter Panel',
  REAR_WHEEL = 'Rear Wheel',
  FRONT_BUMPER = 'Front Bumper',
  REAR_BUMPER = 'Rear Bumper',
  HOOD = 'Hood',
  FRONT_WINDSHIELD = 'Front\nWindshield',
  ROOF = 'Roof',
  REAR_WINDSHIELD = 'Rear\nWindshield',
  TRUNK = 'Trunk',
}

export interface DamagedPartTileInfo {
  damagePartCode: DamagedPartCodes;
  isRightFlipped: boolean;
  titleDirection: TitleDirection;
  tabOrder: number;
}

export enum TitleDirection {
  top = 'TOP',
  overLay = 'OVERLAY',
}

export interface ThemeStyleInfo {
  // SideHeaderStyle
  sideHeaderStyle?: {
    fontFamily: string;
    fontWeight: number;
    fontSize: string;
    fontcolor: string;
  };
  tileImageStyle: {
    selectedFillColor: string;
    strokeColor: string;
    hoverFillColor: string;
    notSelectedFillColor: string;
  };
  tileTitleStyle: {
    textFontFamily: string;
    textFontWeight: number;
    textFontSize: string;
    textFontSizeToFit: string;
    textColor: string;
    selectedTextFontWeight: number;
  };
  outLineStyle: {
    fillColor: string;
  };
}

interface TileImageCustomizationInfo {
  damagedPartName: any;
  themeStyleInfo: ThemeStyleInfo;
  isRightFlipped: boolean;
  titleDirection: TitleDirection;
  tabOrder: number;
  isMobile: boolean;
}

export interface TileInfo {
  damagePartCode: DamagedPartCodes;
  themeStyleInfo: ThemeStyleInfo;
  isSelected: boolean;
  isMobile: boolean;
}
// The default, static state information that is known at the build time
const damagedPartTileInfoCollection: DamagedPartTileInfo[] = [
  {
    damagePartCode: DamagedPartCodes.LEFT_FRONT_WHEEL,
    titleDirection: TitleDirection.top,
    isRightFlipped: false,
    tabOrder: 0,
  },
  {
    damagePartCode: DamagedPartCodes.LEFT_FENDER,
    titleDirection: TitleDirection.top,
    isRightFlipped: false,
    tabOrder: 1,
  },
  {
    damagePartCode: DamagedPartCodes.LEFT_FRONT_DOOR,
    titleDirection: TitleDirection.top,
    isRightFlipped: false,
    tabOrder: 2,
  },
  {
    damagePartCode: DamagedPartCodes.LEFT_REAR_DOOR,
    titleDirection: TitleDirection.top,
    isRightFlipped: false,
    tabOrder: 3,
  },
  {
    damagePartCode: DamagedPartCodes.LEFT_QUARTER_PANEL,
    titleDirection: TitleDirection.top,
    isRightFlipped: false,
    tabOrder: 4,
  },
  {
    damagePartCode: DamagedPartCodes.LEFT_REAR_WHEEL,
    titleDirection: TitleDirection.top,
    isRightFlipped: false,
    tabOrder: 5,
  },
  {
    damagePartCode: DamagedPartCodes.FRONT_BUMPER,
    titleDirection: TitleDirection.top,
    isRightFlipped: false,
    tabOrder: 6,
  },
  {
    damagePartCode: DamagedPartCodes.HOOD,
    titleDirection: TitleDirection.overLay,
    isRightFlipped: false,
    tabOrder: 7,
  },
  {
    damagePartCode: DamagedPartCodes.FRONT_WINDSHIELD,
    titleDirection: TitleDirection.overLay,
    isRightFlipped: false,
    tabOrder: 8,
  },
  {
    damagePartCode: DamagedPartCodes.ROOF,
    titleDirection: TitleDirection.overLay,
    isRightFlipped: false,
    tabOrder: 9,
  },
  {
    damagePartCode: DamagedPartCodes.REAR_WIND_SHIELD,
    titleDirection: TitleDirection.overLay,
    isRightFlipped: false,
    tabOrder: 10,
  },
  {
    damagePartCode: DamagedPartCodes.TRUNK,
    titleDirection: TitleDirection.overLay,
    isRightFlipped: false,
    tabOrder: 11,
  },
  {
    damagePartCode: DamagedPartCodes.REAR_BUMPER,
    titleDirection: TitleDirection.top,
    isRightFlipped: false,
    tabOrder: 12,
  },
  {
    damagePartCode: DamagedPartCodes.RIGHT_FRONT_WHEEL,
    titleDirection: TitleDirection.top,
    isRightFlipped: true,
    tabOrder: 12,
  },
  {
    damagePartCode: DamagedPartCodes.RIGHT_FENDER,
    titleDirection: TitleDirection.top,
    isRightFlipped: true,
    tabOrder: 13,
  },
  {
    damagePartCode: DamagedPartCodes.RIGHT_FRONT_DOOR,
    titleDirection: TitleDirection.top,
    isRightFlipped: true,
    tabOrder: 14,
  },
  {
    damagePartCode: DamagedPartCodes.RIGHT_REAR_DOOR,
    titleDirection: TitleDirection.top,
    isRightFlipped: true,
    tabOrder: 15,
  },
  {
    damagePartCode: DamagedPartCodes.RIGHT_QUARTER_PANEL,
    titleDirection: TitleDirection.top,
    isRightFlipped: true,
    tabOrder: 16,
  },
  {
    damagePartCode: DamagedPartCodes.RIGHT_REAR_WHEEL,
    titleDirection: TitleDirection.top,
    isRightFlipped: true,
    tabOrder: 17,
  },
];

export default function DamagedPartTile(props: TileInfo) {
  let tile = <></>;
  let tileInfo = [];
  const noSelectionColor = props.themeStyleInfo.tileImageStyle.notSelectedFillColor;
  const selectedTextFontWeight = props.themeStyleInfo.tileTitleStyle.selectedTextFontWeight;
  const fillColor = props.isSelected ? props.themeStyleInfo.tileImageStyle.selectedFillColor : noSelectionColor;
  // Font weight change based on selection state
  const fontWeight = props.isSelected ? selectedTextFontWeight : props.themeStyleInfo.tileTitleStyle.textFontWeight;
  const themeStyleInfo = {
    ...props.themeStyleInfo,
    tileImageStyle: {
      ...props.themeStyleInfo.tileImageStyle,
      selectedFillColor: fillColor,
    },
    tileTitleStyle: {
      ...props.themeStyleInfo.tileTitleStyle,
      textFontWeight: fontWeight,
    },
  };

  switch (props.damagePartCode) {
    case DamagedPartCodes.FRONT_BUMPER:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <FrontBumper
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.FRONT_BUMPER}
          titleDirection={tileInfo[0].titleDirection}
          themeStyleInfo={themeStyleInfo}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></FrontBumper>
      );
      break;
    case DamagedPartCodes.FRONT_WINDSHIELD:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <FrontWindShield
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.FRONT_WINDSHIELD}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></FrontWindShield>
      );
      break;
    case DamagedPartCodes.HOOD:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <Hood
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.HOOD}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></Hood>
      );
      break;
    case DamagedPartCodes.LEFT_FENDER:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <Fender
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.FENDER}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></Fender>
      );
      break;
    case DamagedPartCodes.LEFT_FRONT_DOOR:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <FrontDoor
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.FRONT_DOOR}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></FrontDoor>
      );
      break;
    case DamagedPartCodes.LEFT_FRONT_WHEEL:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <Wheel
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.FRONT_WHEEL}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></Wheel>
      );
      break;
    case DamagedPartCodes.LEFT_QUARTER_PANEL:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <QuarterPanel
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.QUARTER_PANEL}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></QuarterPanel>
      );
      break;
    case DamagedPartCodes.LEFT_REAR_DOOR:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <RearDoor
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.REAR_DOOR}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></RearDoor>
      );
      break;
    case DamagedPartCodes.LEFT_REAR_WHEEL:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <Wheel
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.REAR_WHEEL}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></Wheel>
      );
      break;
    case DamagedPartCodes.REAR_BUMPER:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <RearBumper
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.REAR_BUMPER}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></RearBumper>
      );
      break;
    case DamagedPartCodes.REAR_WIND_SHIELD:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <RearWindShield
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.REAR_WINDSHIELD}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></RearWindShield>
      );
      break;
    case DamagedPartCodes.RIGHT_FENDER:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <Fender
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.FENDER}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></Fender>
      );
      break;
    case DamagedPartCodes.RIGHT_FRONT_DOOR:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <FrontDoor
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.FRONT_DOOR}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></FrontDoor>
      );
      break;
    case DamagedPartCodes.RIGHT_FRONT_WHEEL:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <Wheel
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.FRONT_WHEEL}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></Wheel>
      );
      break;
    case DamagedPartCodes.RIGHT_QUARTER_PANEL:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <QuarterPanel
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.QUARTER_PANEL}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></QuarterPanel>
      );
      break;
    case DamagedPartCodes.RIGHT_REAR_DOOR:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <RearDoor
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.REAR_DOOR}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></RearDoor>
      );
      break;
    case DamagedPartCodes.RIGHT_REAR_WHEEL:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <Wheel
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.REAR_WHEEL}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></Wheel>
      );
      break;
    case DamagedPartCodes.ROOF:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <Roof
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.ROOF}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></Roof>
      );
      break;
    case DamagedPartCodes.TRUNK:
      tileInfo = damagedPartTileInfoCollection.filter((info) => info.damagePartCode === props.damagePartCode);
      tile = (
        <Trunk
          themeStyleInfo={themeStyleInfo}
          isRightFlipped={tileInfo[0].isRightFlipped}
          damagedPartName={DamagedPartName.TRUNK}
          titleDirection={tileInfo[0].titleDirection}
          tabOrder={tileInfo[0].tabOrder}
          isMobile={props.isMobile}
        ></Trunk>
      );
      break;
    default:
      break;
  }
  return tile;
}

const FrontBumper = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      <svg xmlns="http://www.w3.org/2000/svg" width="114" height="40" viewBox="0 0 114 40">
        <path
          d="M104.82.02a.448.448 0 0 0-.23 0c-.12.02-11.61 2.47-19.45 3.86-3.51.62-52.78.62-56.29 0C21.02 2.48 9.52.04 9.41.01a.593.593 0 0 0-.23 0C4.95 1.11-.07 2.71 0 4.16c.6 17.83 1.47 27.06 2.55 27.41.06.03.21.12.45.26 9.17 5.29 14.98 6.67 18.23 6.9 9.3.65 22.22 1.16 35.77 1.28 13.55-.12 26.47-.63 35.77-1.28 3.26-.23 9.07-1.61 18.23-6.9.24-.14.39-.23.45-.26 1.08-.35 1.95-9.58 2.55-27.41.07-1.44-4.95-3.05-9.18-4.14Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="M15.01 21.25c-2.75 0-4.98 2.2-4.98 4.91s2.23 4.91 4.98 4.91 4.98-2.2 4.98-4.91-2.23-4.91-4.98-4.91Zm0 8.85c-2.2 0-3.98-1.76-3.98-3.93s1.79-3.93 3.98-3.93 3.98 1.76 3.98 3.93-1.79 3.93-3.98 3.93Zm17-22.63L6.69 3.46c-.92-.15-1.8.44-2.01 1.34-.33 1.48-.53 3.56.43 5.04.53.82 1.35 1.35 2.43 1.58 4.84 1.02 8.19 1.59 10.24 1.75.4.03.93.06 1.54.06 2.14 0 5.24-.34 7.11-2.11l3.76.02c1.09-.1 2.08-1.81 2.18-2.67l.05-.46a.49.49 0 0 0-.42-.54Zm-1.86 2.69-3.92-.02c-.13.04-.27.05-.36.15-2.08 2.11-6.29 2.03-8.01 1.9-2-.16-5.31-.72-10.11-1.73-.82-.17-1.41-.55-1.79-1.15-.82-1.26-.54-3.23-.3-4.29.08-.35.4-.6.75-.6h.12l24.85 3.94c-.08.64-.88 1.75-1.23 1.79Zm-6.66 9.69c-.51-.14-12.52-3.44-16.38-3.01-4.37.5-4.03 4.56-3.55 10.19.52 6.11 19.78 8.76 21.97 9.05h.06c.13 0 .26-.05.35-.15.11-.11.16-.26.14-.41l-2.24-15.27a.494.494 0 0 0-.36-.4Zm-18.94 7.1c-.51-6.06-.6-8.76 2.67-9.13.21-.02.45-.04.72-.04 3.9 0 13.15 2.44 14.96 2.93l2.1 14.3c-6.15-.86-20.09-3.71-20.46-8.07ZM94 26.17c0 2.71 2.23 4.91 4.98 4.91s4.98-2.2 4.98-4.91-2.23-4.91-4.98-4.91S94 23.46 94 26.17Zm1 0c0-2.17 1.79-3.93 3.98-3.93s3.98 1.76 3.98 3.93-1.79 3.93-3.98 3.93S95 28.34 95 26.17ZM70.45 8.81h-26.9c-.82 0-1.49.66-1.49 1.47v6.88c0 .81.67 1.47 1.49 1.47h26.9c.82 0 1.49-.66 1.49-1.47v-6.88c0-.81-.67-1.47-1.49-1.47Zm.5 8.35c0 .27-.22.49-.5.49h-26.9a.5.5 0 0 1-.5-.49v-6.88c0-.27.22-.49.5-.49h26.9c.27 0 .5.22.5.49v6.88Zm10.63-9.15.05.46c.1.85 1.09 2.56 2.18 2.67l3.76-.02c1.88 1.76 4.97 2.11 7.11 2.11.61 0 1.14-.03 1.54-.06 2.05-.16 5.4-.73 10.24-1.75 1.08-.23 1.89-.76 2.43-1.58.96-1.48.77-3.56.43-5.04-.2-.9-1.09-1.49-2.01-1.34L81.99 7.47c-.26.04-.45.28-.42.54Zm1.04.35 24.85-3.94s.08-.01.12-.01c.36 0 .67.24.75.6.24 1.06.52 3.03-.3 4.29-.39.6-.98.97-1.79 1.15-4.8 1.01-8.1 1.58-10.11 1.73-1.72.13-5.94.21-8.01-1.9-.09-.1-.24-.11-.36-.15l-3.92.02c-.35-.04-1.15-1.15-1.23-1.79Zm7.53 11.88-2.24 15.27c-.02.15.03.31.14.41.09.1.22.15.35.15h.06c2.19-.28 21.46-2.93 21.97-9.05.48-5.63.82-9.69-3.55-10.19-3.86-.44-15.87 2.87-16.38 3.01-.19.05-.33.21-.36.4ZM88.99 35l2.1-14.3c1.82-.49 11.06-2.93 14.96-2.93.27 0 .51.01.72.04 3.27.37 3.19 3.07 2.67 9.13-.37 4.35-14.31 7.21-20.46 8.07Zm-4.36-12.91a.526.526 0 0 0-.41-.15c-.2.02-20.45 2.29-27.22 2.3-6.76 0-27.01-2.28-27.22-2.3a.482.482 0 0 0-.41.15c-.11.11-.16.26-.14.41l1.65 11.2c.23 1.7 1.72 2.98 3.46 2.98h45.33c1.74 0 3.23-1.28 3.46-2.98l1.65-11.2c.02-.15-.03-.3-.14-.41Zm-2.5 11.47c-.16 1.22-1.23 2.14-2.47 2.14H34.33c-1.24 0-2.3-.92-2.47-2.14l-1.55-10.57c3.53.39 20.56 2.23 26.69 2.23 6.13 0 23.16-1.84 26.69-2.23l-1.55 10.57ZM104.82.02a.448.448 0 0 0-.23 0c-.12.02-11.61 2.47-19.45 3.86-3.51.62-52.78.62-56.29 0C21.02 2.48 9.52.04 9.41.01a.593.593 0 0 0-.23 0C4.95 1.11-.07 2.71 0 4.16c.6 17.83 1.47 27.06 2.55 27.41.06.03.21.12.45.26 9.17 5.29 14.98 6.67 18.23 6.9 9.3.65 22.22 1.16 35.77 1.28 13.55-.12 26.47-.63 35.77-1.28 3.26-.23 9.07-1.61 18.23-6.9.24-.14.39-.23.45-.26 1.08-.35 1.95-9.58 2.55-27.41.07-1.44-4.95-3.05-9.18-4.14ZM.99 4.16ZM110.98 30.7c-.08.04-.21.12-.48.27-9 5.19-14.65 6.54-17.8 6.77-9.28.65-22.17 1.16-35.7 1.27-13.52-.12-26.42-.62-35.7-1.27-3.15-.22-8.8-1.57-17.8-6.77-.27-.16-.41-.23-.48-.27-.65-1.07-1.27-9.97-1.68-18.4 3.88 1.16 22.81 6.81 25.55 7.3 2.98.53 24.75 2.63 30.12 2.63s27.14-2.09 30.12-2.63c2.73-.49 21.67-6.14 25.55-7.3-.41 8.43-1.04 17.33-1.68 18.4Zm1.73-19.44c-2.83.85-23.04 6.89-25.77 7.38-2.97.53-24.6 2.61-29.94 2.61s-26.98-2.08-29.94-2.61c-2.73-.49-22.94-6.53-25.77-7.38-.12-2.52-.22-4.97-.29-7.12.35-.68 4.53-2.16 8.32-3.15 1.24.26 11.93 2.52 19.36 3.84 3.61.64 53.03.64 56.64 0 7.43-1.32 18.13-3.58 19.36-3.84 3.78.99 7.97 2.47 8.32 3.15-.07 2.15-.17 4.6-.29 7.12Zm.3-7.1Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const RearBumper = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}

      <svg xmlns="http://www.w3.org/2000/svg" width="114" height="34" viewBox="0 0 114 34">
        <path
          d="M113.88 7.34 107.47.17a.5.5 0 0 0-.69-.05c-.16.13-.22.34-.16.52-.04.62-1.2 3.58-2.22 4.3-4.12 2.94-7.65 3.62-13.55 3.96-5.33.31-12.29.58-18.85.74-.33 0-.67.02-1 .03v4.22c0 .27-.22.49-.5.49h-27c-.28 0-.5-.22-.5-.49V9.67c-.33 0-.67-.02-1-.03-6.56-.16-13.52-.43-18.85-.74-5.9-.35-9.43-1.03-13.55-3.96-1.02-.73-2.18-3.69-2.22-4.3.06-.19 0-.39-.16-.52a.509.509 0 0 0-.69.05L.12 7.34c-.09.1-.13.24-.12.37.01.15 1.48 15.39 2.23 20.42.58 3.9 2.33 5.87 5.18 5.87.18 0 .36 0 .55-.02.19-.02.35-.13.42-.31.01-.04 1.58-3.68 8.08-3.7 6.63-.02 6.98-.48 7.15-.71.09-.12.13-.31.09-.45 0 0-.23-.89.38-1.68.73-.95 2.39-1.46 4.8-1.46 5.85-.02 6.08 1.5 6.25 2.84l.04.29c.02.11.06.2.14.28.26.25.32.31 10.76.05 4.23-.11 17.61-.11 21.84 0 10.44.27 10.51.21 10.76-.05a.42.42 0 0 0 .14-.28l.04-.29c.17-1.34.41-2.86 6.25-2.84 2.41 0 4.07.51 4.8 1.46.61.79.38 1.67.38 1.68-.04.15 0 .33.09.45.17.22.52.69 7.15.71 6.51.02 8.07 3.66 8.08 3.7.07.17.23.29.42.31.19.02.37.02.55.02 2.85 0 4.59-1.97 5.18-5.87.75-5.03 2.22-20.26 2.23-20.42a.503.503 0 0 0-.12-.37Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="M17.22 10.76c-1.93 0-3.5 1.54-3.5 3.44s1.57 3.44 3.5 3.44 3.5-1.54 3.5-3.44-1.57-3.44-3.5-3.44Zm0 5.9c-1.38 0-2.5-1.1-2.5-2.46s1.12-2.46 2.5-2.46 2.5 1.1 2.5 2.46-1.12 2.46-2.5 2.46Zm79.56.98c1.93 0 3.5-1.54 3.5-3.44s-1.57-3.44-3.5-3.44-3.5 1.54-3.5 3.44 1.57 3.44 3.5 3.44Zm0-5.9c1.38 0 2.5 1.1 2.5 2.46s-1.12 2.46-2.5 2.46-2.5-1.1-2.5-2.46 1.12-2.46 2.5-2.46Zm17.1-4.4L107.47.17a.5.5 0 0 0-.69-.05c-.16.13-.22.34-.16.52-.04.62-1.2 3.58-2.22 4.3-4.12 2.94-7.65 3.62-13.55 3.96-5.33.31-12.29.58-18.85.74-.33 0-.67.02-1 .03v4.22c0 .27-.22.49-.5.49h-27c-.28 0-.5-.22-.5-.49V9.67c-.33 0-.67-.02-1-.03-6.56-.16-13.52-.43-18.85-.74-5.9-.35-9.43-1.03-13.55-3.96-1.02-.73-2.18-3.69-2.22-4.3.06-.19 0-.39-.16-.52a.509.509 0 0 0-.69.05L.12 7.34c-.09.1-.13.24-.12.37.01.15 1.48 15.39 2.23 20.42.58 3.9 2.33 5.87 5.18 5.87.18 0 .36 0 .55-.02.19-.02.35-.13.42-.31.01-.04 1.58-3.68 8.08-3.7 6.63-.02 6.98-.48 7.15-.71.09-.12.13-.31.09-.45 0 0-.23-.89.38-1.68.73-.95 2.39-1.46 4.8-1.46 5.85-.02 6.08 1.5 6.25 2.84l.04.29c.02.11.06.2.14.28.26.25.32.31 10.76.05 4.23-.11 17.61-.11 21.84 0 10.44.27 10.51.21 10.76-.05a.42.42 0 0 0 .14-.28l.04-.29c.17-1.34.41-2.86 6.25-2.84 2.41 0 4.07.51 4.8 1.46.61.79.38 1.67.38 1.68-.04.15 0 .33.09.45.17.22.52.69 7.15.71 6.51.02 8.07 3.66 8.08 3.7.07.17.23.29.42.31.19.02.37.02.55.02 2.85 0 4.59-1.97 5.18-5.87.75-5.03 2.22-20.26 2.23-20.42a.503.503 0 0 0-.12-.37ZM97.2 28.99c-3.96-.02-5.38-.21-5.87-.32.04-.49 0-1.33-.61-2.13-.94-1.23-2.82-1.85-5.6-1.85h-.06c-6.11 0-6.92 1.7-7.18 3.61-1.28.07-6.04-.06-9.94-.16-4.24-.11-17.65-.11-21.89 0-3.9.1-8.66.22-9.94.16-.26-1.91-1.07-3.61-7.18-3.61h-.06c-2.78 0-4.66.63-5.6 1.85-.61.8-.65 1.63-.61 2.13-.48.11-1.9.3-5.87.32l-1.91-4.78c-.1-.24-.31-.94-.02-1.37.29-.43 1.03-.51 1.58-.5 2.84.05 78.24.05 81.08 0 .55-.02 1.29.07 1.58.5.29.43.08 1.14-.02 1.37l-1.91 4.78Zm13.58-1c-.52 3.46-1.94 5.07-4.38 5.03-.52-.93-2.55-3.76-8.14-4l1.77-4.43s.59-1.32-.07-2.29c-.43-.64-1.26-.93-2.43-.94-2.83.05-78.21.05-81.05 0-1.17 0-2 .3-2.43.94-.65.97-.08 2.26-.07 2.29l1.77 4.43c-5.6.24-7.63 3.07-8.14 4-2.43.03-3.86-1.57-4.38-5.03-.25-1.65-.57-4.41-.9-7.38.66-.74 3.84-4.04 7.05-3.1.51.1.65.36.88.89.3.68.71 1.61 2.48 1.61h88.53c1.77 0 2.18-.93 2.48-1.61.23-.53.37-.79.88-.89 3.21-.94 6.39 2.37 7.05 3.1-.32 2.96-.65 5.73-.9 7.38Zm1.04-8.67c-1.35-1.32-4.29-3.68-7.43-2.77-1 .2-1.32.92-1.55 1.45-.27.61-.43.99-1.59 1.01-1.8-.01-86.69-.01-88.48 0-1.16-.02-1.32-.4-1.59-1.01-.23-.53-.55-1.25-1.55-1.45-3.14-.91-6.08 1.44-7.43 2.77-.55-5.08-1.06-10.37-1.17-11.48L6.6 1.59c.42 1.31 1.39 3.42 2.42 4.15C13.34 8.82 17 9.53 23.1 9.89c5.35.31 12.33.58 18.91.74v3.26c0 .81.67 1.47 1.5 1.47h27c.83 0 1.5-.66 1.5-1.47v-3.26c6.58-.16 13.56-.43 18.91-.74 6.09-.36 9.76-1.07 14.08-4.15 1.03-.73 2.01-2.84 2.42-4.15L113 7.84c-.11 1.11-.62 6.4-1.17 11.48Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const FrontDoor = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  let transformExpression = 'scale(1,1)';
  if (props.isRightFlipped) {
    transformExpression = 'scale(-1,1)';
  }
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="43"
        viewBox="0 0 50 43"
        transform={transformExpression}
      >
        <path
          d="M49.91.38a.505.505 0 0 0-.37-.21c-11.9-.99-22.83 2.25-34.46 10.37-1.46.15-2.61.53-3.11 1.06-.47.39-5.68 4.99-6.35 5.58l-.72.03c-.05 0-.1.01-.15.03-7.61 2.8-3.86 24.42-3.69 25.34.04.24.25.41.49.41h.01l41.77-1.16a.497.497 0 0 0 .49-.53c-.05-.68-.08-1.33-.12-1.99.02-.06.04-.13.04-.2 0-.08-.03-.15-.06-.21-.73-14.56 2.09-22.14 2.33-22.76 0 0 0-.02.01-.03 0 0 .01-.03.01-.04L49.98.78c.04-.14 0-.29-.08-.41Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="M49.91.38a.505.505 0 0 0-.37-.21c-11.9-.99-22.83 2.25-34.46 10.37-1.46.15-2.61.53-3.11 1.06-.47.39-5.68 4.99-6.35 5.58l-.72.03c-.05 0-.1.01-.15.03-7.61 2.8-3.86 24.42-3.69 25.34.04.24.25.41.49.41h.01l41.77-1.16a.497.497 0 0 0 .49-.53c-.05-.68-.08-1.33-.12-1.99.02-.06.04-.13.04-.2 0-.08-.03-.15-.06-.21-.73-14.56 2.09-22.14 2.33-22.76 0 0 0-.02.01-.03 0 0 .01-.03.01-.04L49.98.78c.04-.14 0-.29-.08-.41Zm-3.02.65-3.75 14.53-24.63 1.06c.44-.47.65-1.08.64-1.81-.03-1.31-.08-3.92-2.22-4.3C27.05 3.75 36.66.72 46.89 1.03ZM15.48 11.51c.29-.02.58-.04.9-.04h.02c1.24 0 1.72.92 1.77 3.37 0 .49-.12.86-.4 1.15-.51.52-1.57.79-3.14.81h-.06c-1.41.01-4.14.12-6.17.21-.4.02-.78.04-1.11.05 1.73-1.53 5-4.41 5.38-4.73.34-.35 1.38-.7 2.82-.82ZM1.98 41.99c-.05-.28-.11-.69-.18-1.21l40.93-1.13c.02.41.04.79.07 1.21L1.99 41.99Zm40.69-3.34L1.66 39.78c-.28-2.15-.62-5.37-.66-8.67-.06-5.15.59-11.55 4.03-12.9l1.87-.09 7.68-.33.87-.04 29.37-1.26c-.74 2.19-2.77 9.47-2.16 22.16Zm2.5-23.18-.98.04 3.73-14.44c.32.02.64.02.96.04l-3.7 14.36Zm-9.57 7.2c.32.19 1.19.62 2.35.62 1.27 0 2.05-.46 2.4-.68.05-.01.13-.02.23-.02.63-.05 2.1-.17 2.1-1.42 0-.82-1.16-1.05-1.54-1.12-.7-.14-1.66-.21-2.76-.21s-6.54.08-6.54 1.74c0 .35 0 1.01 3.78 1.11Zm1.7-1.83c2.48-.1 4 .16 4.36.39-.09.24-.63.31-1.16.35-.25.02-.39.03-.53.1-.04.02-.09.05-.15.08-.29.17-.88.52-1.87.52-1.13 0-1.91-.52-1.92-.52a.46.46 0 0 0-.27-.09c-.91-.02-1.97-.11-2.58-.22.65-.25 2.05-.52 4.12-.61Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const RearDoor = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  let transformExpression = 'scale(1,1)';
  if (props.isRightFlipped) {
    transformExpression = 'scale(-1,1)';
  }
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="47"
        transform={transformExpression}
        viewBox="0 0 50 47"
      >
        <path
          d="M47.62 7.56C42.48 2.72 29.88.19 10.17.02h-.02C9.42.02 8.7 0 7.95 0c-.23 0-.43.15-.48.38-.04.14-2.66 10.4-4.39 17.09-.04.07-.07.15-.07.24-.65 2.51-1.16 4.48-1.35 5.16C.71 26.3-.71 33.94.4 46.54c.02.26.24.46.5.46h.02l30.18-1.39a.51.51 0 0 0 .48-.49c0-.03.05-3.13 1.34-5.45 1.34-2.41 15.31-22.35 15.42-22.51.04-.05 4.12-5.02-.73-9.58Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="M40.65 20.06c-.79-.16-1.87-.24-3.13-.24-.75 0-7.36.05-7.36 1.92 0 .36 5.57 1.9 6.88 1.9 1.42 0 2.3-.52 2.67-.75l.04-.03c.06-.01.15-.02.27-.03.69-.06 2.32-.19 2.32-1.56 0-.88-1.28-1.13-1.7-1.22Zm-.7 1.78c-.27.02-.43.04-.57.11-.04.02-.1.05-.17.09-.33.2-1.01.6-2.16.6-1.3 0-2.21-.6-2.21-.61a.46.46 0 0 0-.27-.09c-1.16-.02-2.5-.15-3.15-.3.66-.31 2.41-.69 4.91-.79 3.06-.13 4.82.23 5.02.43 0 .39-.67.5-1.4.56Zm7.68-14.27C42.48 2.72 29.88.19 10.17.02h-.02C9.42.02 8.7 0 7.95 0c-.23 0-.43.15-.48.38-.04.14-2.66 10.4-4.39 17.09-.04.07-.07.15-.07.24-.65 2.51-1.16 4.48-1.35 5.16C.71 26.3-.71 33.94.4 46.54c.02.26.24.46.5.46h.02l30.18-1.39a.51.51 0 0 0 .48-.49c0-.03.05-3.13 1.34-5.45 1.34-2.41 15.31-22.35 15.42-22.51.04-.05 4.12-5.02-.73-9.58Zm.15 8.68-13.75.3 2.08-13.07c5.88 1.4 9.09 3.18 10.83 4.82 3.59 3.38 1.56 6.92.84 7.95ZM32.94 2.82l-2.2 13.8-24.36.53 4.23-16.14c9.67.11 16.9.8 22.32 1.79Zm.98.19c.42.08.82.17 1.22.25l-2.12 13.31-1.26.03 2.16-13.59ZM8.34 1h1.24L5.34 17.15l-1.15.02C5.72 11.22 7.86 2.86 8.34 1ZM1.36 45.97c-.04-.42-.06-.82-.09-1.23l29.5-1.58c-.1.6-.14 1.12-.17 1.47L1.35 45.98Zm30.69-6.8c-.53.96-.87 2.02-1.08 2.97L1.2 43.74c-.69-10.83.57-17.49 1.43-20.6.18-.66.67-2.54 1.3-4.95l43.12-.93c-2.57 3.67-13.76 19.69-15 21.91Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const Fender = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  let transformExpression = 'scale(1,1)';
  if (props.isRightFlipped) {
    transformExpression = 'scale(-1,1)';
  }
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="55"
        height="30"
        transform={transformExpression}
        viewBox="0 0 55 30"
      >
        <path
          d="M54.8.12c-.17-.13-.27-.2-7.46.03-.14 0-.27.07-.36.17-.03.03-2.98 3.3-10.76 2.97C23.87 2.76 5.34 6.77.25 9.56c-.19.1-.29.31-.24.52.04.21.22.36.44.38.08 0 7.69.72 11.85 3.05.14.08.3.08.45.02.09-.04 9.37-4.02 16.46.03 4.59 2.62 7.3 8 8.06 16 .02.25.24.44.49.44h11.17c.15 0 .29-.06.38-.17.09-.11.13-.26.1-.4 0-.05-.19-.96-.4-2.44 0-.03.02-.05.02-.08a.37.37 0 0 0-.06-.21C48.04 20.14 46.6 3.79 54.65.97c.17-.06.29-.21.32-.38a.492.492 0 0 0-.19-.46Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="M54.8.12c-.17-.13-.27-.2-7.46.03-.14 0-.27.07-.36.17-.03.03-2.98 3.3-10.76 2.97C23.87 2.76 5.34 6.77.25 9.56c-.19.1-.29.31-.24.52.04.21.22.36.44.38.08 0 7.69.72 11.85 3.05.14.08.3.08.45.02.09-.04 9.37-4.02 16.46.03 4.59 2.62 7.3 8 8.06 16 .02.25.24.44.49.44h11.17c.15 0 .29-.06.38-.17.09-.11.13-.26.1-.4 0-.05-.19-.96-.4-2.44 0-.03.02-.05.02-.08a.37.37 0 0 0-.06-.21C48.04 20.14 46.6 3.79 54.65.97c.17-.06.29-.21.32-.38s-.05-.35-.19-.46ZM29.71 12.73c-6.97-3.98-15.58-.8-17.13-.17-.6-.32-1.27-.61-1.96-.87 4.26-1.56 13.23-4.6 20.19-.41 4.85 2.92 7.84 8.9 8.9 17.76h-1.49c-.85-8.09-3.71-13.57-8.51-16.3Zm10.99 16.3c-.07-.56-.14-1.11-.22-1.65h7.6c.11.7.2 1.26.27 1.65h-7.66Zm7.24-2.61h-7.62c-1.34-7.81-4.36-13.18-9.01-15.97-7.65-4.6-17.4-1.01-21.56.52l-.59.22C6.62 10.4 3.93 9.93 2.23 9.7c6.44-2.62 22.95-5.92 33.94-5.45 7.37.32 10.67-2.42 11.4-3.14 1.5-.05 3.49-.1 4.94-.13-6.63 4.57-5.47 18.97-4.57 25.45Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const Hood = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      {props.titleDirection === TitleDirection.overLay && (
        <Typography
          style={{ ...textStyle, userSelect: 'none' }}
          gutterBottom
          position={'absolute'}
          sx={{ marginTop: '1rem' }}
          align={'center'}
        >
          {props.damagedPartName}
        </Typography>
      )}
      <svg xmlns="http://www.w3.org/2000/svg" width="140" height="92" viewBox="0 0 140 92">
        <path
          d="m126.15 82-.05-.68c-.2-2.66-.33-7.48-.49-13.59-.49-18.47-1.22-46.37-5.14-51.13-.25-.3-.57-.55-.95-.73-17.25-8.31-44.86-9.68-48.76-9.83v-.03l-.48.01h-.48v.02c-3.89.15-31.51 1.52-48.76 9.83-.39.19-.71.43-.95.73-3.91 4.76-4.65 32.67-5.14 51.13-.16 6.11-.29 10.93-.49 13.59l-.05.68c-.28 3.53-.47 5.86 3.91 8.63l1.89 1.2c.18.11.38.17.58.17.14 0 .27-.03.41-.08.34-.14.59-.44.68-.8.14-.59.87-1.27 2.06-1.9l.13-.07c10.86-5.83 26.4-8.78 46.21-8.78s35.35 2.95 46.21 8.78l.13.07c1.18.63 1.92 1.31 2.06 1.9.09.37.34.67.68.81.13.05.27.08.41.08.2 0 .4-.06.58-.17l1.89-1.2c4.39-2.77 4.2-5.1 3.91-8.63Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="m126.15 82-.05-.68c-.2-2.66-.33-7.48-.49-13.59-.49-18.47-1.22-46.37-5.14-51.13-.25-.3-.57-.55-.95-.73-17.25-8.31-44.86-9.68-48.76-9.83v-.03l-.48.01h-.48v.02c-3.89.15-31.51 1.52-48.76 9.83-.39.19-.71.43-.95.73-3.91 4.76-4.65 32.67-5.14 51.13-.16 6.11-.29 10.93-.49 13.59l-.05.68c-.28 3.53-.47 5.86 3.91 8.63l1.89 1.2c.18.11.38.17.58.17.14 0 .27-.03.41-.08.34-.14.59-.44.68-.8.14-.59.87-1.27 2.06-1.9l.13-.07c10.86-5.83 26.4-8.78 46.21-8.78s35.35 2.95 46.21 8.78l.13.07c1.18.63 1.92 1.31 2.06 1.9.09.37.34.67.68.81.13.05.27.08.41.08.2 0 .4-.06.58-.17l1.89-1.2c4.39-2.77 4.2-5.1 3.91-8.63Zm-110.76.08.05-.68c.2-2.68.33-7.52.49-13.64.45-17.21 1.21-46.03 4.91-50.52.15-.19.36-.34.62-.47 6.31-3.04 14.04-5.14 21.46-6.59-2.18 3.09-9.17 13.13-14.18 21.43-4.93 8.15-9.41 34.64-9.87 58.19l-.03-.02c-3.88-2.44-3.73-4.2-3.45-7.7Zm5.52 8.8c-.02.08-.07.11-.17.1l-.88-.56c.4-23.56 4.84-50.2 9.74-58.3 5.67-9.38 13.88-21.01 14.74-22.21 2.35-.43 4.65-.81 6.85-1.12L22.36 89.03c-.8.59-1.29 1.21-1.45 1.86Zm49.86-11.52h-1c-19.67.05-35.17 3.03-46.07 8.84L52.3 8.63c9.96-1.36 17.71-1.61 17.98-1.62.26 0 8.01.25 17.98 1.62l28.59 79.57c-10.9-5.82-26.4-8.79-46.07-8.84Zm48.96 11.63s-.07-.03-.09-.11c-.15-.64-.64-1.27-1.45-1.86L89.37 8.79c2.21.32 4.51.69 6.85 1.12.86 1.21 9.07 12.83 14.74 22.21 4.89 8.09 9.34 34.73 9.74 58.28l-.97.59Zm1.98-1.21-.03.02c-.47-23.55-4.94-50.04-9.87-58.19-5.02-8.3-12.01-18.34-14.18-21.43 7.43 1.45 15.15 3.55 21.46 6.59.26.12.46.28.62.47 3.7 4.49 4.45 33.31 4.91 50.52.16 6.12.29 10.96.49 13.64l.05.68c.28 3.5.42 5.26-3.45 7.7Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const QuarterPanel = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  let transformExpression = 'scale(1,1)';
  if (props.isRightFlipped) {
    transformExpression = 'scale(-1,1)';
  }
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="54"
        height="38"
        transform={transformExpression}
        viewBox="0 0 54 38"
      >
        <path
          d="M51.47 11.18s-.1-.03-.15-.03c-14.2-.59-18.59-3.1-20.95-4.44-.37-.21-.69-.39-.99-.54C27.15 5.1 15.95.25 15.48.04a.468.468 0 0 0-.33-.02l-2.54.72c-.21.06-.35.24-.37.46s.11.41.31.5c.07.03 6.65 2.82 9.19 4.24 2.11 1.18 1.56 2.76 1.51 2.89-.41.79-1.57 2.97-2.05 3.57-.89 1.12-3.33.61-4.2.31-.21-.07-.45 0-.58.2L.09 37.21c-.1.16-.11.36-.03.52.09.17.26.27.44.27h6.71c.23 0 .44-.16.49-.39 1.44-6.16 4.14-10.12 8.02-11.78 6.32-2.71 13.76 1.64 13.83 1.69.11.07.25.09.38.06 0 0 9.49-2.38 14.37-3.62 4.9-1.24 5.63-2.71 5.73-2.99a.515.515 0 0 0-.23-.61c-.02-.01-.61-.36-3.22-2.44-.89-.71-1.12-1.13-1.18-1.34.02-.05.03-.11.03-.17v-.04c.1-.22.5-.42.81-.58.14-.07.28-.14.4-.21.46-.27 3.88-.75 6.92-1.05.25-.03.44-.23.45-.49.07-1.86-2.42-2.82-2.53-2.86Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="M51.47 11.18s-.1-.03-.15-.03c-14.2-.59-18.59-3.1-20.95-4.44-.37-.21-.69-.39-.99-.54C27.15 5.1 15.95.25 15.48.04a.468.468 0 0 0-.33-.02l-2.54.72c-.21.06-.35.24-.37.46s.11.41.31.5c.07.03 6.65 2.82 9.19 4.24 2.11 1.18 1.56 2.76 1.51 2.89-.41.79-1.57 2.97-2.05 3.57-.89 1.12-3.33.61-4.2.31-.21-.07-.45 0-.58.2L.09 37.21c-.1.16-.11.36-.03.52.09.17.26.27.44.27h6.71c.23 0 .44-.16.49-.39 1.44-6.16 4.14-10.12 8.02-11.78 6.32-2.71 13.76 1.64 13.83 1.69.11.07.25.09.38.06 0 0 9.49-2.38 14.37-3.62 4.9-1.24 5.63-2.71 5.73-2.99a.515.515 0 0 0-.23-.61c-.02-.01-.61-.36-3.22-2.44-.89-.71-1.12-1.13-1.18-1.34.02-.05.03-.11.03-.17v-.04c.1-.22.5-.42.81-.58.14-.07.28-.14.4-.21.46-.27 3.88-.75 6.92-1.05.25-.03.44-.23.45-.49.07-1.86-2.42-2.82-2.53-2.86ZM2.13 35.98H5.1c-.1.33-.19.67-.28 1.01H1.45l.68-1.01Zm27.75-9.44c-1.24-.69-8.25-4.34-14.55-1.65-4.1 1.76-6.97 5.82-8.51 12.09h-.95c1.89-6.86 5.1-11.22 9.55-12.94 6.07-2.35 12.88.84 15.43 2.25-.43.11-.77.19-.96.24Zm16.07-7.84c1.55 1.24 2.41 1.88 2.87 2.21-.47.44-1.71 1.28-4.77 2.06-3.28.83-8.64 2.18-11.8 2.98-1.37-.86-9.64-5.76-17.19-2.85-4.37 1.69-7.6 5.68-9.64 11.87H2.81l11.75-17.49 29.9-.56c.18.53.66 1.11 1.5 1.78Zm.17-4c-.1.06-.21.11-.33.17-.45.22-1.02.52-1.28 1.03l-29.26.54 1.8-2.68c.99.27 3.69.82 4.93-.75.63-.81 2.09-3.61 2.17-3.77.36-.88.43-2.88-1.93-4.21-1.9-1.07-5.89-2.83-7.97-3.73l.99-.28c1.42.61 11.64 5.05 13.7 6.04.28.14.58.31.93.51 2.43 1.39 6.95 3.96 21.32 4.57.48.2 1.44.72 1.72 1.42-1.73.18-6.03.67-6.8 1.13Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const Roof = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      {props.titleDirection === TitleDirection.overLay && (
        <Typography
          style={{ ...textStyle, userSelect: 'none' }}
          gutterBottom
          position={'absolute'}
          sx={{ marginTop: '8rem' }}
          align={'center'}
        >
          {props.damagedPartName}
        </Typography>
      )}
      <svg xmlns="http://www.w3.org/2000/svg" width="140" height="227" viewBox="0 0 140 227">
        <path
          d="m111.26 133.02.02-.24-.18-.17c-5.05-4.77-35.96-5.52-40.33-5.6v-.02h-.98c-4.37.08-35.28.83-40.33 5.6l-.18.17.02.24c.02.25 2.1 24.77 2.25 31.88.15 7.64-.04 48.8-1.44 55.36a1.5 1.5 0 0 0 .93 1.72c3.08 1.17 14.94 4.97 38.74 5.02s.5 0 .5 0h.5c23.8-.06 35.66-3.85 38.74-5.02.7-.26 1.09-.99.93-1.72-1.4-6.56-1.59-47.72-1.44-55.36.14-7.11 2.23-31.63 2.25-31.88Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="m111.26 133.02.02-.24-.18-.17c-5.05-4.77-35.96-5.52-40.33-5.6v-.02h-.98c-4.37.08-35.28.83-40.33 5.6l-.18.17.02.24c.02.25 2.1 24.77 2.25 31.88.15 7.64-.04 48.8-1.44 55.36a1.5 1.5 0 0 0 .93 1.72c3.08 1.17 14.94 4.97 38.74 5.02s.5 0 .5 0h.5c23.8-.06 35.66-3.85 38.74-5.02.7-.26 1.09-.99.93-1.72-1.4-6.56-1.59-47.72-1.44-55.36.14-7.11 2.23-31.63 2.25-31.88Zm-1.79 87.45c.05.24-.07.48-.31.56-3.06 1.16-14.92 4.96-38.89 4.96s-35.82-3.8-38.89-4.96a.49.49 0 0 1-.31-.56c1.46-6.88 1.58-49.62 1.46-55.59-.14-6.75-2.01-29.05-2.23-31.69 5.61-4.61 39.5-5.17 39.96-5.18.46 0 34.35.57 39.96 5.18-.22 2.64-2.09 24.94-2.23 31.69-.12 5.97 0 48.71 1.46 55.59Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
        <path
          d="m111.26 133.02.02-.24-.18-.17c-5.05-4.77-35.96-5.52-40.33-5.6v-.02h-.98c-4.37.08-35.28.83-40.33 5.6l-.18.17.02.24c.02.25 2.1 24.77 2.25 31.88.15 7.64-.04 48.8-1.44 55.36a1.5 1.5 0 0 0 .93 1.72c3.08 1.17 14.94 4.97 38.74 5.02s.5 0 .5 0h.5c23.8-.06 35.66-3.85 38.74-5.02.7-.26 1.09-.99.93-1.72-1.4-6.56-1.59-47.72-1.44-55.36.14-7.11 2.23-31.63 2.25-31.88Zm-1.79 87.45c.05.24-.07.48-.31.56-3.06 1.16-14.92 4.96-38.89 4.96s-35.82-3.8-38.89-4.96a.49.49 0 0 1-.31-.56c1.46-6.88 1.58-49.62 1.46-55.59-.14-6.75-2.01-29.05-2.23-31.69 5.61-4.61 39.5-5.17 39.96-5.18.46 0 34.35.57 39.96 5.18-.22 2.64-2.09 24.94-2.23 31.69-.12 5.97 0 48.71 1.46 55.59Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const Trunk = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      {props.titleDirection === TitleDirection.overLay && (
        <Typography
          style={{ ...textStyle, userSelect: 'none' }}
          gutterBottom
          position={'absolute'}
          sx={{ marginTop: '17rem' }}
          align={'center'}
        >
          {props.damagedPartName}
        </Typography>
      )}
      <svg xmlns="http://www.w3.org/2000/svg" width="140" height="300" viewBox="0 0 140 300">
        <path
          d="M116.07 270.78c-.42-4.46-2.54-6.76-3.68-7.99l-.26-.29c-.21-.23-.5-.37-.81-.38-.31-.02-.61.1-.85.32-2.51 2.38-10.76 4.02-16.22 5.1-5.96 1.18-23.61 1.61-23.97 1.61-.36 0-18.01-.43-23.97-1.61-5.46-1.08-13.71-2.72-16.22-5.1a1.15 1.15 0 0 0-1.65.06l-.26.29c-1.14 1.23-3.26 3.53-3.68 7.99-.69 7.28.42 12.65 1.69 15.25 1.94 3.97 6.22 6.52 12.74 7.58 13.03 2.11 28.67 2.51 31.21 2.51h.3c2.54 0 18.18-.4 31.21-2.51 6.52-1.05 10.8-3.6 12.74-7.58 1.27-2.6 2.38-7.97 1.69-15.25Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="M116.07 270.78c-.42-4.46-2.54-6.76-3.68-7.99l-.26-.29c-.21-.23-.5-.37-.81-.38-.31-.02-.61.1-.85.32-2.51 2.38-10.76 4.02-16.22 5.1-5.96 1.18-23.61 1.61-23.97 1.61-.36 0-18.01-.43-23.97-1.61-5.46-1.08-13.71-2.72-16.22-5.1a1.15 1.15 0 0 0-1.65.06l-.26.29c-1.14 1.23-3.26 3.53-3.68 7.99-.69 7.28.42 12.65 1.69 15.25 1.94 3.97 6.22 6.52 12.74 7.58 13.03 2.11 28.67 2.51 31.21 2.51h.3c2.54 0 18.18-.4 31.21-2.51 6.52-1.05 10.8-3.6 12.74-7.58 1.27-2.6 2.38-7.97 1.69-15.25Zm-2.59 14.81c-1.79 3.66-5.82 6.03-12 7.03-12.49 2.02-27.38 2.45-30.71 2.49s-.49 0-.49 0h-.29c-2.87-.04-18.15-.43-30.91-2.5-6.18-1-10.22-3.36-12-7.03-1.21-2.48-2.26-7.64-1.59-14.71.39-4.12 2.36-6.25 3.42-7.4l.27-.3s.08-.05.11-.05.08 0 .12.05c2.72 2.58 10.81 4.18 16.71 5.35 5.6 1.11 20.76 1.55 23.67 1.62v.02l.49-.01h.49v-.01c2.92-.08 18.08-.51 23.67-1.62 5.91-1.17 13.99-2.77 16.71-5.35.04-.04.09-.05.12-.05s.07 0 .11.05l.27.3c1.06 1.15 3.03 3.28 3.42 7.4.67 7.07-.39 12.24-1.59 14.71Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const Wheel = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
    userSelect: 'none',
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  const circleStyle = {
    fill: fillColor,
  };
  const pathStyle = {
    fill: props.themeStyleInfo.tileImageStyle.strokeColor,
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{ textStyle }}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom align={'center'} sx={{ ...textStyle }}>
          {props.damagedPartName}
        </Typography>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        xmlSpace="preserve"
        id="Layer_2_00000112627387968729462060000013050250796208174492_"
        x="0"
        y="0"
        version="1.1"
        viewBox="0 0 40 40"
      >
        <circle cx="19.9" cy="20" r="18.8" style={circleStyle} />
        <path
          d="M20 .3C9.1.3.3 9.1.3 20S9.1 39.7 20 39.7 39.7 30.9 39.7 20 30.9.3 20 .3zm0 38.4C9.7 38.7 1.3 30.3 1.3 20S9.7 1.3 20 1.3 38.7 9.7 38.7 20 30.3 38.7 20 38.7z"
          style={pathStyle}
        />
        <path
          d="M20 15.8c-2.3 0-4.2 1.9-4.2 4.2s1.9 4.2 4.2 4.2 4.2-1.9 4.2-4.2-1.9-4.2-4.2-4.2zm0 7.4c-1.8 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2 3.2 1.4 3.2 3.2-1.4 3.2-3.2 3.2z"
          style={pathStyle}
        />
        <path
          d="M20 8.1C13.5 8.1 8.1 13.5 8.1 20S13.5 31.9 20 31.9 31.9 26.5 31.9 20 26.5 8.1 20 8.1zm0 1c.9 0 1.8.1 2.6.3-1.2 3.4-2.1 3.8-2.5 3.8-.4 0-1.3-.4-2.7-3.9.9-.1 1.7-.2 2.6-.2zm-5.6 1.6c1.6 3.3 1.2 4.2.9 4.5-.2.3-1.2.7-4.6-.9 1-1.5 2.3-2.7 3.7-3.6zM9.1 20c0-.9.1-1.8.3-2.6 3.4 1.2 3.8 2.1 3.8 2.5 0 .4-.4 1.3-3.9 2.7-.1-.9-.2-1.7-.2-2.6zm1.6 5.6c3.3-1.6 4.2-1.2 4.5-.9.3.2.7 1.2-.9 4.6-1.5-1-2.7-2.3-3.6-3.7zm9.3 5.3c-.9 0-1.8-.1-2.6-.3 1.2-3.4 2.1-3.8 2.5-3.9.4 0 1.3.4 2.7 3.9-.9.2-1.7.3-2.6.3zm5.6-1.6c-1.6-3.3-1.2-4.2-.9-4.5.2-.3 1.2-.7 4.6.9-1 1.5-2.3 2.7-3.7 3.6zm5.3-9.3c0 .9-.1 1.8-.3 2.6-3.4-1.2-3.9-2.1-3.9-2.5 0-.4.4-1.3 3.9-2.7.2.9.3 1.7.3 2.6zm-.6-3.5c-3.1 1.2-4.6 2.4-4.6 3.6 0 1.3 1.5 2.4 4.6 3.4-.1.5-.3.9-.5 1.3-3-1.4-4.9-1.6-5.8-.7-.9.9-.6 2.7.8 5.6-.4.2-.8.4-1.2.5-1.2-3.1-2.4-4.6-3.6-4.6-1.3 0-2.4 1.5-3.4 4.6-.5-.1-.9-.3-1.3-.5 1.4-3 1.6-4.9.7-5.8-.9-.9-2.7-.6-5.6.8-.2-.4-.4-.8-.5-1.2 3.1-1.2 4.6-2.4 4.6-3.6 0-1.3-1.5-2.4-4.6-3.4.1-.4.3-.9.6-1.3 1.8.8 3.2 1.3 4.2 1.3.7 0 1.2-.2 1.6-.6.9-.9.6-2.7-.8-5.6.4-.2.8-.4 1.2-.5 1.2 3.1 2.4 4.6 3.6 4.6 1.3 0 2.4-1.5 3.4-4.6.5.1.9.3 1.3.6-1.4 3.1-1.6 4.9-.7 5.8.4.3.8.5 1.5.5 1 0 2.4-.5 4.2-1.3 0 .3.1.7.3 1.1zm-5.5-1.1c-.3-.2-.7-1.2.9-4.6 1.5.9 2.7 2.2 3.6 3.7-3.3 1.5-4.2 1.1-4.5.9z"
          style={pathStyle}
        />
      </svg>
    </Grid>
  );
};

const FrontWindShield = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      {props.titleDirection === TitleDirection.overLay && (
        <Typography
          style={{
            ...textStyle,
            fontSize: props.themeStyleInfo.tileTitleStyle.textFontSizeToFit,
            userSelect: 'none',
          }}
          gutterBottom
          position={'absolute'}
          sx={{
            marginTop: '5.5rem',
            whiteSpace: 'pre-wrap',
            lineHeight: '95%',
          }}
          align="center"
        >
          {props.damagedPartName}
        </Typography>
      )}
      <svg xmlns="http://www.w3.org/2000/svg" width="140" height="128" viewBox="0 0 140 128">
        <path
          d="M111.67 94.53c-7.73-3.74-24.86-6.47-40.89-6.53s-.5 0-.5 0h-.5c-16.03.06-33.16 2.78-40.89 6.53-7.24 3.51-5.61 9.23-5.07 11.11.05.17.09.32.11.42l.11.53c1.83 8.93 3.43 14.72 4.78 17.3 1.4 2.67 2.39 4.11 5.82 4.11 1.61 0 3.75-.32 6.72-.97 11.91-2.61 23.77-2.58 28.22-2.57h1.38c4.45-.02 16.31-.04 28.22 2.57 2.96.65 5.1.96 6.71.96 3.45 0 4.45-1.45 5.88-4.19.9-1.72 2.45-6.11 4.74-17.24l.11-.52c.02-.1.06-.25.11-.42.54-1.88 2.17-7.6-5.07-11.11Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="M111.67 94.53c-7.73-3.74-24.86-6.47-40.89-6.53s-.5 0-.5 0h-.5c-16.03.06-33.16 2.78-40.89 6.53-7.24 3.51-5.61 9.23-5.07 11.11.05.17.09.32.11.42l.11.53c1.83 8.93 3.43 14.72 4.78 17.3 1.4 2.67 2.39 4.11 5.82 4.11 1.61 0 3.75-.32 6.72-.97 11.91-2.61 23.77-2.58 28.22-2.57h1.38c4.45-.02 16.31-.04 28.22 2.57 2.96.65 5.1.96 6.71.96 3.45 0 4.45-1.45 5.88-4.19.9-1.72 2.45-6.11 4.74-17.24l.11-.52c.02-.1.06-.25.11-.42.54-1.88 2.17-7.6-5.07-11.11Zm4.12 10.84c-.06.2-.1.36-.13.48l-.11.53c-2.26 11.01-3.77 15.31-4.69 17.06-1.81 3.45-2.42 4.62-11.46 2.64-12.02-2.63-23.94-2.6-28.44-2.59H69.6c-4.49-.01-16.42-.04-28.44 2.59-9.04 1.98-9.65.82-11.5-2.71-.87-1.67-2.38-5.96-4.64-16.97l-.11-.54c-.03-.12-.07-.28-.13-.48-.53-1.86-1.94-6.81 4.55-9.96 7.69-3.72 24.91-6.43 40.95-6.43s33.26 2.7 40.95 6.43c6.5 3.15 5.09 8.09 4.55 9.96Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

const RearWindShield = (props: TileImageCustomizationInfo) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    if (!props.isMobile) {
      setHover(true);
    }
  };
  const handleMouseLeave = () => {
    if (!props.isMobile) {
      setHover(false);
    }
  };
  const textStyle = {
    fontFamily: props.themeStyleInfo.tileTitleStyle.textFontFamily,
    fontWeight: props.themeStyleInfo.tileTitleStyle.textFontWeight,
    fontSize: props.themeStyleInfo.tileTitleStyle.textFontSize,
    color: props.themeStyleInfo.tileTitleStyle.textColor,
  };
  const fillColor = hover
    ? props.themeStyleInfo.tileImageStyle.hoverFillColor
    : props.themeStyleInfo.tileImageStyle.selectedFillColor;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabOrder + 1}
    >
      {props.titleDirection === TitleDirection.top && (
        <Typography gutterBottom style={{ ...textStyle, userSelect: 'none' }} align={'center'}>
          {props.damagedPartName}
        </Typography>
      )}
      {props.titleDirection === TitleDirection.overLay && (
        <Typography
          style={{
            ...textStyle,
            fontSize: props.themeStyleInfo.tileTitleStyle.textFontSizeToFit,
            marginTop: '14.5rem',
            whiteSpace: 'pre-wrap',
            lineHeight: '95%',
            userSelect: 'none',
          }}
          gutterBottom
          position={'absolute'}
          align="center"
        >
          {props.damagedPartName}
        </Typography>
      )}
      <svg xmlns="http://www.w3.org/2000/svg" width="140" height="267" viewBox="0 0 140 267">
        <path
          d="M33 234s-2 12-2 20c0 2-1 6 3 8 0 0 20 5 37 5s34-4 36-5c2-2 3-4 3-7s-1-28-7-28-33 2-35 2-13-1-16-1-12-2-14-1-2 1-3 2-2 5-2 5Z"
          style={{ fill: fillColor, transition: 'fill 0.2s ease-in-out' }}
        />
        <path
          d="M107.39 231.09c-1.24-4.07-4.23-5.72-8.88-4.88-4.45.8-25.89 2.51-28.23 2.51-4.11 0-23.78-1.71-28.23-2.51-4.66-.84-7.65.81-8.88 4.88-1.55 5.1-3.27 19.33-2.81 25.85.2 2.92 1.01 5.29 9.17 7.08 11.92 2.61 24.8 2.96 30.26 2.98s.49 0 .49 0h.49c5.46-.02 18.34-.37 30.26-2.98 8.16-1.79 8.97-4.16 9.17-7.08.45-6.52-1.27-20.75-2.81-25.85Zm1.83 25.78c-.18 2.64-.87 4.5-8.39 6.14-12.19 2.67-25.43 2.96-30.56 2.96s-18.37-.29-30.56-2.96c-7.52-1.65-8.2-3.5-8.39-6.14-.44-6.42 1.25-20.44 2.77-25.47 1.08-3.55 3.62-4.92 7.77-4.17 4.28.77 21.27 2.53 28.4 2.53s24.11-1.76 28.4-2.53c4.16-.74 6.7.62 7.77 4.17 1.52 5.02 3.22 19.04 2.77 25.47Z"
          style={{ fill: props.themeStyleInfo.tileImageStyle.strokeColor }}
        />
      </svg>
    </Grid>
  );
};

export const MapBase = (props: any) => {
  const fillColor = props.fillColor;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="140" height="300" viewBox="0 0 140 300">
      <path
        d="M139.11 113.74c-.41-1.08-4.32-3.19-8.12-5.01-.16-38.62-.3-70.35-.3-71.1-.04-5.21-.11-16.04-3.43-20.23-5.88-7.43-17.32-12.62-33.99-15.42C80.92-.09 70.15 0 70 0c-.24 0-10.97-.08-23.27 1.98-16.67 2.8-28.11 7.99-33.99 15.42-3.32 4.19-3.39 15.02-3.43 20.23 0 .75-.14 32.48-.3 71.1-3.8 1.83-7.7 3.93-8.11 5.01-.07.19-1.76 4.7-.31 6.27.24.26.64.52 1.27.52.26 0 .56-.04.91-.15 1.49-.46 3.94-1.22 6.2-1.92-.25 59.1-.53 129.09-.51 129.89.26 10.1 5.9 35.14 7.07 38.51.71 2.03 4.5 5.17 13.03 7.91 7.01 2.25 19.8 4.97 40.96 5.23s.49 0 .49 0h.49c21.16-.26 33.95-2.98 40.96-5.23 8.53-2.74 12.32-5.88 13.03-7.91 1.17-3.37 6.81-28.41 7.07-38.51.02-.79-.27-70.79-.51-129.89 2.25.7 4.71 1.46 6.2 1.92.35.11.65.15.91.15.63 0 1.03-.26 1.27-.52 1.45-1.57-.23-6.08-.3-6.27Zm-9.11-5.49c-2.25-1.06-4.35-1.99-5.51-2.49l-.58-.25-.11.62c-.03.15-.64 3.72-.11 7.12.16 1.04.4 1.78.65 2.31.31.99.38 12.95.45 23.5.05 8.31.1 13.75.16 17.33-.74 2.49-9.27 7.3-13.34 9.38.15-12.77.69-24.45 1.87-28.6 1.11-3.91 3.16-11.52 5.14-18.88 2.37-8.82 5.06-18.82 5.38-19.51.43-.95 3.84-4.92 5.92-7.27.02 5.37.05 10.97.07 16.73Zm-3.65 54.93c.96-.44 2.96-1.47 3.87-1.94.09 21.97.17 42.84.23 58.64-.11.11-2.58 2.5-3.42 4.36-.57 1.26-1.8 3.65-3.23 5.99 2.27-12.79 3.55-60.72 2.54-67.05Zm-4.23 69.63c-1.25 1.76-2.52 3.17-3.53 3.53-.29.1-.53.1-.74 0-1.81-.92-3.62-9.97-4.91-24.16l11.77-4.32c-.85 17.27-1.92 24.32-2.59 24.92v.02Zm3.01-34.73c-.11 3.14-.24 6.04-.36 8.7l-11.91 4.37c-.18-2.02-.34-4.14-.5-6.35-.42-6.04-.74-17.78-.77-29.9 1.8-.17 8.78-1.11 14.07-5.6.05 6.44-.11 17.16-.53 28.77Zm-13.54-24.18v-2.73c5.6-.89 10.95-5.13 13.27-6.97.22-.17.43-.34.62-.49.08.79.13 2.26.16 4.29-4.98 4.64-12.14 5.7-14.05 5.9Zm12.66-10.49c-2.23 1.77-7.36 5.84-12.65 6.74 0-1.09.01-2.18.02-3.26 1.95-.98 10.46-5.38 13.39-8.74.06 2.57.14 3.84.25 4.48-.23.16-.53.4-1.01.78ZM10.07 91.52c2.08 2.35 5.48 6.32 5.92 7.27.31.69 3 10.69 5.38 19.51 1.98 7.36 4.03 14.96 5.14 18.88 1.18 4.15 1.72 15.83 1.87 28.59-4.07-2.08-12.6-6.89-13.34-9.38.07-3.57.11-9.01.16-17.33.06-10.55.13-22.51.45-23.49.26-.53.49-1.27.65-2.31.53-3.4-.08-6.97-.11-7.12l-.11-.62-.58.25c-1.16.5-3.26 1.43-5.51 2.49.02-5.76.05-11.36.07-16.73Zm5.21 116.34 11.78 4.32c-1.29 14.19-3.1 23.24-4.91 24.16-.2.1-.44.1-.74 0-.99-.35-2.23-1.72-3.46-3.44l.02-.08c-1.09-.91-2.03-11.93-2.69-24.96Zm-1.63-44.68c-1 6.33.28 54.25 2.54 67.05-1.43-2.34-2.66-4.74-3.23-5.99-.84-1.85-3.31-4.25-3.42-4.36.06-15.8.14-36.67.23-58.64.91.47 2.91 1.49 3.87 1.94Zm-3.86-3.06c.06-13.92.11-28.24.17-41.98 2.05-.64 3.78-1.17 4.17-1.29.1 0 .25-.02.41-.08-.19 3.01-.26 10.2-.33 22.29-.06 9.71-.12 20.59-.38 23.11-1.3-.62-3.95-1.99-4.04-2.04Zm5.44 46.65c-.67-13.6-1.04-29.11-.95-37.53 5.3 4.54 12.32 5.49 14.13 5.66-.02 12.12-.35 23.86-.77 29.9-.15 2.21-.32 4.33-.5 6.35l-11.92-4.37Zm-.93-38.83c.04-1.98.1-3.45.2-4.25.19.15.42.33.64.5 2.32 1.84 7.67 6.08 13.27 6.97v2.73c-1.92-.2-9.13-1.26-14.12-5.96Zm1.46-4.53c-.48-.38-.79-.62-1.01-.78.11-.64.19-1.9.25-4.48 2.93 3.36 11.44 7.76 13.39 8.74.01 1.08.02 2.17.02 3.26-5.29-.9-10.42-4.97-12.65-6.74ZM2.48 119.42c-.56.17-.95.14-1.17-.09-.72-.77-.12-3.58.51-5.23.36-.96 7.03-4.33 13.48-7.15.15 1.16.39 3.74.01 6.16-.16 1.02-.37 1.65-.58 2.06-.32.63-.61.68-.59.69l-.11-.02-.11.03s-8.11 2.52-11.43 3.55Zm128.07 128.9c-.26 10.02-5.85 34.87-7.01 38.21-1.36 3.9-16.23 12.09-53.54 12.47-37.3-.39-52.18-8.57-53.54-12.47-1.16-3.34-6.75-28.19-7.01-38.21 0-.22.03-10.76.1-27.01.78.83 2.01 2.23 2.52 3.35.05.11 5.35 11.32 9.01 12.63.26.09.5.14.74.14.27 0 .53-.06.77-.18 3.24-1.64 5.08-18.5 6.04-32.36.98-14.05 1.42-58.87-1.18-67.98-1.11-3.91-3.16-11.51-5.14-18.86-3.16-11.76-5.11-18.95-5.43-19.66-.62-1.36-5.59-6.98-6.81-8.35.12-28.21.21-49.63.23-52.39.04-5.09.11-15.69 3.21-19.61C26.41 1.74 64.76 1.02 69.51 1S70 1 70 1h.49c4.74.03 43.1.74 55.99 17.03 3.1 3.92 3.18 14.52 3.21 19.61.02 2.76.11 24.19.23 52.39-1.22 1.37-6.2 6.99-6.81 8.35-.32.71-2.27 7.9-5.43 19.66-1.98 7.35-4.02 14.96-5.14 18.86-2.6 9.11-2.16 53.93-1.18 67.98.97 13.86 2.8 30.72 6.04 32.36.24.12.5.18.77.18.24 0 .48-.05.74-.14 3.67-1.31 8.96-12.52 9.01-12.63.51-1.12 1.74-2.53 2.52-3.35l.1 27.01Zm-.34-88.19c-.09.05-2.74 1.42-4.04 2.04-.25-2.52-.32-13.4-.38-23.11-.07-12.09-.14-19.28-.33-22.29.16.06.3.08.41.08.39.12 2.11.66 4.17 1.29.06 13.74.11 28.07.17 41.98Zm8.47-40.8c-.22.23-.61.26-1.17.09-3.32-1.02-11.43-3.55-11.43-3.55l-.07-.04-.11.02s-.81-.11-1.22-2.75c-.38-2.42-.14-5 .01-6.16 6.45 2.82 13.12 6.2 13.48 7.15.63 1.65 1.22 4.46.51 5.23Z"
        style={{ fill: fillColor }}
      />
    </svg>
  );
};
